import { useCallback } from 'react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { useTranslation } from '@frontend/i18n';
import { PaginatedTaskList, taskCenterTrackingIds, TaskListFilters } from '@frontend/task-center-components';
import { ContactTaskListStoreProvider, useTaskCenterStore } from '@frontend/task-center-scope';
import { theme } from '@frontend/theme';
import { Button, Heading } from '@frontend/design-system';

interface Props {
  contactId: string;
}

const ContactTaskTabContentInner = ({ contactId }: Props) => {
  const { t } = useTranslation('contacts');
  const { setTaskMode, setIsTaskCenterOpen, isTaskCenterOpen, setSelectedTask } = useTaskCenterStore([
    'setTaskMode',
    'setIsTaskCenterOpen',
    'isTaskCenterOpen',
    'setSelectedTask',
  ]);

  const onCreateTask = useCallback(() => {
    // SP-TODO: correct this later
    setSelectedTask({
      patient: { id: contactId, name: '' },
      title: '',
      locationId: '',
      type: TaskCenterTypes.TaskType.TYPE_UNKNOWN,
      source: TaskCenterTypes.TaskSource.SOURCE_UNKNOWN,
    });
    setTaskMode('create');
    if (!isTaskCenterOpen) {
      setIsTaskCenterOpen(true);
    }
  }, [setSelectedTask, contactId, setTaskMode, isTaskCenterOpen, setIsTaskCenterOpen]);

  return (
    <section css={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <header
        css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: theme.spacing(1, 2) }}
      >
        <Heading level={3} css={{ fontSize: theme.font.size.large }}>
          {t('Tasks')}
        </Heading>
        <div css={{ display: 'flex', gap: theme.spacing(1) }}>
          <Button
            variant='secondary'
            iconName='draft'
            size='medium'
            label={t('Create Task')}
            hoverLabel={t('Create Task')}
            trackingId={taskCenterTrackingIds.createTaskButton}
            onClick={onCreateTask}
          />
          <TaskListFilters />
        </div>
      </header>

      <PaginatedTaskList listQueryEnabled={Boolean(contactId)} onCreateTask={onCreateTask} patientId={contactId} />
    </section>
  );
};

export const ContactTaskTabContent = ({ contactId }: Props) => {
  return (
    <ContactTaskListStoreProvider>
      <ContactTaskTabContentInner contactId={contactId} />
    </ContactTaskListStoreProvider>
  );
};
